module.exports = __webpack_public_path__ + "img/horizontal_7_6_pp3_8017.f50485de.png";